var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPayments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.5h-15C2.6 3.5 1 5.1 1 7v10c0 1.9 1.6 3.5 3.5 3.5h14.9c1.9 0 3.5-1.6 3.5-3.5V7c.1-1.9-1.5-3.5-3.4-3.5zM3 7c0-.8.7-1.5 1.5-1.5h14.9c.9 0 1.6.7 1.6 1.5v1H3V7zm18 10c0 .8-.7 1.5-1.5 1.5h-15c-.8 0-1.5-.7-1.5-1.5v-6h18v6z",
    fill: "#050505"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1,
    cy: 14.6,
    r: 1,
    opacity: 0.5,
    fill: "#050505"
  })));
}

export default SvgIconPayments;